import React from "react";

const LeaveTypeSelect = ({ value, onChange, choices }) => {
  return (
    <div className="form-group">
      <label>Leave Type:</label>
      <select
        name="category"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">-- Select Leave Type --</option>
        {choices.map((c) => (
          <option value={c.id} remaining={c.remaining}>
            {c.name} - {c.remaining} Remaining
          </option>
        ))}
      </select>
    </div>
  );
};

export default LeaveTypeSelect;
